import styled from 'styled-components';
import { MIN_CARD_WIDTH } from '@/components/AdCard/AdCard.constants';
import { CustomLink } from '@/components/CustomLink/CustomLink';
import { SkeletonLoader } from '@/components/SkeletonLoader/SkeletonLoader';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.palette.primary.background};
  border-radius: 21px 21px 0 0;
  padding: 15px 0 50px;
  gap: 20px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 20px 15px 75px;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 42px;
  gap: 5px;
  padding: 10px 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    height: 30px;
    padding: 5px 0;
  }
`;

export const TitleSkeletonLoader = styled(SkeletonLoader).attrs({
  borderRadius: 7,
})`
  height: 22px;
  width: 190px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    height: 20px;
    width: 150px;
  }
`;

export const ShowAllLinkSkeletonLoader = styled(SkeletonLoader).attrs({
  borderRadius: 7,
})`
  height: 22px;
  width: 40px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    height: 20px;
  }
`;

export const ShowAllLink = styled(CustomLink)`
  font-size: 15px;
  text-decoration: underline;

  &:hover {
    color: ${({ theme }) => theme.palette.brand.main};
  }
`;

export const Title = styled.div`
  font-size: 18px;
  font-weight: 500;
  font-style: normal;
  color: ${({ theme }) => theme.palette.primary.labels};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 16px;
  }
`;

export const AdCardsBox = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(${MIN_CARD_WIDTH}px, 1fr));
  justify-content: center;
  gap: 10px 9px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-template-columns: repeat(2, minmax(${MIN_CARD_WIDTH}px, 1fr));
  }
`;
